export default __webpack_public_path__ + "static/media/GarrettKenyon.9310b2f7.jpg";